// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { EOL } from "node:os";
import util from "node:util";
import * as process from "node:process";
export function log(message, ...args) {
    process.stderr.write(`${util.format(message, ...args)}${EOL}`);
}
//# sourceMappingURL=log.js.map